// allContext.js
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import React, { createContext, useContext } from 'react';
import camelcaseKeys from "camelcase-keys";

import { sortDistrictList, addManagerList2MemberList, addAssignList2MemberList, addNumber2MemberList, sortManagerList, sortMemberList, isSelected, getChip, getServiceListItem } from '../Utilities/common';
import { DEBUG, API_BASE_URL_UAT, API_BASE_URL, BOOK_LIST } from './constant';

import reducer from '../Imports/reducerImports';

const allContext = createContext();

export const Shared = ({ children }) => {

    const { setDistrictList, setServiceOptionListItem, setServiceOptionList, setSupervisorList, setManagerList, setAssignList, setServiceListItem, setServiceList, setMemberList } = reducer;

    const dispatch = useDispatch(); // dispatch(
    const memberList = useSelector((state) => state.all.memberList);
    const assignList = useSelector((state) => state.all.assignList);
    const managerList = useSelector((state) => state.all.managerList);
    const districtList = useSelector((state) => state.all.districtList);
    const username = useSelector((state) => state.signIn.username);

    const putMemberListItem = async (httpPostData) => { // UserName, CreationDateTimeHK and RevisionDateTimeHK ok
        try {
        // const httpPostData = {
        //   Credential: credential,
        //   VerseFontSize: VerseFontSize,
        //   Updated: { VerseFontSize: true }
        // };
        const url = API_BASE_URL + 'api/MemberListItem/Put/';
        //dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('putUserListItem')));
        //dispatch(setLoading4Home(true));
        await axios.put(url, httpPostData);
        //getUserListItem();
        } catch (error) {
        console.log(error);
        } finally {
        //dispatch(setLoading4Home(false));       
        }      
    }

    const getDistrictList = async () => {
        try {
            const httpPostData = {
                //ServiceID: serviceID,
            };
            const url = API_BASE_URL + 'api/DistrictList/Get/';
            const response = await axios.post(url, httpPostData);
            const axiosDistrictList = camelcaseKeys(response.data, { deep: true });
            sortDistrictList(axiosDistrictList);
            dispatch(setDistrictList(axiosDistrictList));         
        } catch (error) {
            console.log(error);
        } finally {

        }      
    }

    const updateDBSupervisorList = async (serviceID, selectedMemberList) => {        
        try {
            if (selectedMemberList.length === 0) {
                const httpPostData = {
                    ServiceID: serviceID,
                };
                const url = API_BASE_URL + 'api/SupervisorList/Put/Invalid';
                const response = await axios.put(url, httpPostData);
            } else {
                const list = selectedMemberList.map(member => ({UserName: username , ServiceID: serviceID, MemberID: member.id}));
                const httpPostData = list;
                const url = API_BASE_URL + 'api/SupervisorList/Post/';
                const response = await axios.post(url, httpPostData);
            }
        } catch (error) {
            console.log(error);
        } finally {

        } 
    }

    const getSupervisorList = async () => {
        try {
            const httpPostData = {
                //ServiceID: serviceID,
            };
            const url = API_BASE_URL + 'api/SupervisorList/Get/';
            const response = await axios.post(url, httpPostData);
            const reactList = camelcaseKeys(response.data, { deep: true });
            dispatch(setSupervisorList(reactList));
        } catch (error) {
            console.log(error);
        } finally {

        }      
    }

    const updateDBManagerList = async (serviceID, selectedMemberList) => {        
        try {
            if (selectedMemberList.length === 0) {
                const httpPostData = {
                    ServiceID: serviceID,
                };
                const url = API_BASE_URL + 'api/ManagerList/Put/Invalid';
                const response = await axios.put(url, httpPostData);
            } else {
                const list = selectedMemberList.map(member => ({ServiceID: serviceID, MemberID: member.id}));
                const httpPostData = list;
                const url = API_BASE_URL + 'api/ManagerList/Post/';
                const response = await axios.post(url, httpPostData);
            }
        } catch (error) {
            console.log(error);
        } finally {

        } 
    }

    const getManagerList = async (memberList) => {
        try {
            const httpPostData = {
                //ServiceID: serviceID,
            };
            const url = API_BASE_URL + 'api/ManagerList/Get/';
            const response = await axios.post(url, httpPostData);
            const axiosManagerList = camelcaseKeys(response.data, { deep: true });
            dispatch(setManagerList(axiosManagerList));    

            const list = addManagerList2MemberList(memberList, axiosManagerList);
            dispatch(setMemberList(list));            
        } catch (error) {
            console.log(error);
        } finally {

        }      
    }

    const getAssignList = async (memberList) => {
        try {
            const httpPostData = {
                //ServiceID: serviceID,
            };
            const url = API_BASE_URL + 'api/AssignList/Get/All/';
            const response = await axios.post(url, httpPostData);
            const reactList = camelcaseKeys(response.data, { deep: true });
            dispatch(setAssignList(reactList));

            const list = addAssignList2MemberList(memberList, reactList);
            dispatch(setMemberList(list));

            getManagerList(list);
        } catch (error) {
            console.log(error);
        } finally {

        }      
    }

    const updateAssignList = async (serviceID, selectedMemberList) => {        
        try {
            if (selectedMemberList.length === 0) {
                const httpPostData = {
                    ServiceID: serviceID,
                };
                const url = API_BASE_URL + 'api/AssignList/Put/Invalid';
                const response = await axios.put(url, httpPostData);
            } else {
                const list = selectedMemberList.map(member => ({ServiceID: serviceID, MemberID: member.id}));
                const httpPostData = list;
                const url = API_BASE_URL + 'api/AssignList/Post/';
                const response = await axios.post(url, httpPostData);
            }
        } catch (error) {
            console.log(error);
        } finally {

        } 
    }

    const getServiceList = async () => {
        try {
            const httpPostData = {
                Credential: 123,
            };
            const url = API_BASE_URL + 'api/ServiceList/Get/';
            const response = await axios.post(url, httpPostData);
            const reactList = camelcaseKeys(response.data, { deep: true });
            dispatch(setServiceList(reactList));
            dispatch(setServiceListItem(reactList[0]));

            const list = reactList.map(serviceListItem => ({
                name: DEBUG ? `${serviceListItem.name} ID${serviceListItem.id}` : `${serviceListItem.name}`,
                code: serviceListItem.id
            }));
            dispatch(setServiceOptionList(list));
            dispatch(setServiceOptionListItem(list[0]));
        } catch (error) {
            console.log(error);
        } finally {

        }      
    }

    const getMemberList = async () => {
        try {
            const httpPostData = {
                Credential: 123,
            };
            const url = API_BASE_URL + 'api/MemberList/Get/';
            const response = await axios.post(url, httpPostData);
            const axiosMemberList = camelcaseKeys(response.data, { deep: true });
            sortMemberList(axiosMemberList);
            dispatch(setMemberList(axiosMemberList));

            getAssignList(axiosMemberList);
        } catch (error) {
            console.log(error);
        } finally {

        }      
    }

    return (
        <allContext.Provider value={{ putMemberListItem, getDistrictList, updateDBSupervisorList, getSupervisorList, updateDBManagerList, getManagerList, getAssignList, updateAssignList, getServiceList, getMemberList }}>
            {children}
        </allContext.Provider>
    );

}

export const useShared = () => {
  return useContext(allContext);
};